import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { RootState } from "../../../../../models";
import { post as Ajax_post } from "../../../app/Ajax";
import { trackWebshopClickEvent } from "../../../google-analytics/googleAnalyticsEventHelper";
import { VALIDATION_FIELD } from "../../../rapidform/formValidation";
import { API_URL_REGISTRATION_REGISTER_CARD, API_URL_REGISTRATION_VERIFY_UPDATED_NAME } from "../../api";
import {
    PREPAID_REGISTRATION_VERIFY_UPDATED_NAME,
    PREPAID_REGISTRATION_ADD_SIM_AND_PHONE_NUMBER,
} from "../actionTypes";
import * as PREPAID_SELECTORS from "../selectors";

export const registerSimCard = (): ThunkAction<void, RootState, unknown, AnyAction> => (dispatch, getState) => {
    const state = getState();
    const { values } = PREPAID_SELECTORS.getFormById(state, "registerPrepaidForm");
    const personalDetails = {
        simEnd: values.simCardAndPhoneNumber[VALIDATION_FIELD.PREPAID_SIM_NUMBER],
        phoneNumber: values.simCardAndPhoneNumber[VALIDATION_FIELD.PRODUCT_USER_PHONE],
    };

    const { simEnd, phoneNumber } = personalDetails;

    return dispatch({
        type: PREPAID_REGISTRATION_ADD_SIM_AND_PHONE_NUMBER,
        payload: Ajax_post<{ status: string }>(
            {
                url: API_URL_REGISTRATION_REGISTER_CARD,
                data: { phoneNumber, simEnd },
            },
            dispatch,
        ).then((res) => {
            // Track to GA
            trackWebshopClickEvent({
                action: "click",
                text: "Prepaid reg submit sim form",
                type: "button",
                url: "/mobilabonnement/kontantkort/registrering/",
                context: "prepaid_reg_submit_sim_form",
            });
            return {
                status: res.status,
            };
        }),
    });
};

export const verifyUpdatedName =
    (updatedFirstName: string, updatedLastName: string): ThunkAction<Promise<void>, RootState, unknown, AnyAction> =>
    async (dispatch) => {
        const payload = Ajax_post({
            url: API_URL_REGISTRATION_VERIFY_UPDATED_NAME,
            data: {
                updatedFirstName,
                updatedLastName,
            },
        });
        dispatch({
            type: PREPAID_REGISTRATION_VERIFY_UPDATED_NAME,
            payload,
        });
        return payload;
    };
